import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

/**
 *
 * @param {Object} data object containing date (number || string), pattern (string), and locale "date-fns locale" (string)
 * @returns formatted date string
 */
export const formatDate = ({ date, pattern, locale }) => {
  if (!date) return "";
  return format(date, pattern, { locale });
};

export const formatDateInRiyadhZone = (date, pattern = "yyyy-MM-dd", config = {}) => {
  if (!date) return "";

  return formatInTimeZone(date, "Asia/Riyadh", pattern, config);
};

export const getLocalizedClubName = (clubName, language) => {
  const fullName = String(clubName ?? "").trim();
  const separatorIndex = fullName.indexOf("-");

  if (separatorIndex === -1) return fullName;

  const englishName = fullName.slice(0, separatorIndex).trim();
  const arabicName = fullName.slice(separatorIndex + 1).trim();

  if (!englishName || !arabicName) return fullName;
  return language === "ar" ? arabicName : englishName;
};

export const getGenderFreePassPlansIds = () => {
  return {
    male: 118,
    female: 117,
  };
};
export const getGenderFreePassPlanId = (gender) => {
  const GENDER_PLAN_ID = getGenderFreePassPlansIds();
  return GENDER_PLAN_ID[gender];
};

export const getFreePassPlansIds = () => {
  const GENDER_PLAN_ID = getGenderFreePassPlansIds();
  return Object.values(GENDER_PLAN_ID);
};
